import React from 'react';
import loadable from '@loadable/component';
import Modal from '../../../../components/Modal';
import FullScreenLoader from '../../../../components/FullScreenLoader';
import { MODALS } from '../../../../constants';

const Filters = loadable(() => import('./FiltersMobile'), {
  fallback: <FullScreenLoader />,
});

const FiltersMobile = ({ onClickOutside, ...props }) => {
  const modalName = MODALS.FILTERS_MOBILE;

  return (
    <Modal
      name={modalName}
      onClickOutside={onClickOutside}
      className="Listview__Filters__Mobile__root"
    >
      <Filters {...props} />
    </Modal>
  );
};

export default FiltersMobile;
